var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:{ done: _setup.isDone },on:{"click":_setup.toggleDone}},[_c('VueShowdown',{staticClass:"markdown-instruction",attrs:{"markdown":_vm.instruction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }